import { Link } from '@reach/router'
import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

// Motivos con los que el api rechaza el alta (api#564): los devuelve tanto el chequeo previo
// (GET plans/team/:id/subscription-check) como POST /subscriptions. `invalid_plan_code` es
// el nombre que usaba #562.
export const BLOCKED_REASONS = [
  'forbidden',
  'plan_required',
  'invalid_plan',
  'invalid_plan_code',
  'agenda_cap_exceeded',
  'subscription_exists',
  'not_approved',
  'approval_expired',
  'approval_used',
]

const messageFor = (t, reason, plan, checkoutLink) => {
  switch (reason) {
    case 'forbidden':
      return t('subscription_blocked_forbidden', 'No tenés permiso para gestionar la suscripción de esta cuenta. Pedíselo a un administrador.')
    case 'plan_required':
      return t('subscription_blocked_plan_required', 'Elegí un plan para suscribirte.')
    case 'invalid_plan':
    case 'invalid_plan_code':
      return t('subscription_save_error_invalid_plan', 'Ese plan no está disponible.')
    case 'agenda_cap_exceeded':
      return t('subscription_save_error_agenda_cap', 'Tenés más agendas activas de las que incluye {{plan}}.', { plan })
    case 'subscription_exists':
      return checkoutLink
        ? t('subscription_blocked_pending', 'Tu cuenta ya tiene un alta pendiente. Terminala cargando el medio de pago.')
        : t('subscription_blocked_exists', 'Tu cuenta ya tiene una suscripción activa. Para cambiar de plan, solicitalo desde Planes.')
    case 'not_approved':
      return t('subscription_blocked_not_approved', 'Para contratar {{plan}} primero lo tiene que aprobar el equipo comercial. Solicitalo desde Planes.', { plan })
    case 'approval_expired':
      return t('subscription_blocked_approval_expired', 'La aprobación para contratar {{plan}} venció. Volvé a solicitarla desde Planes.', { plan })
    case 'approval_used':
      return t('subscription_blocked_approval_used', 'La aprobación para contratar {{plan}} ya se usó. Si necesitás otro cambio, solicitalo desde Planes.', { plan })
    default:
      return t('subscription_save_error_retry', 'No pudimos completar el alta. Revisá los datos e intentá nuevamente.')
  }
}

// Aviso de por qué no se puede contratar, con la salida que corresponde: el checkout de
// Increase para un alta pendiente, Planes para el resto. Sin permiso no hay a dónde ir.
export default function Blocked({ reason, plan, checkoutLink }) {
  const { t } = useTranslation()
  return (
    <div className={styles.saveError} role="alert" data-testid="subscription-blocked">
      {messageFor(t, reason, plan, checkoutLink)}{' '}
      {reason === 'subscription_exists' && checkoutLink ? (
        <a href={checkoutLink}>{t('subscription_blocked_finish', 'Completar alta')}</a>
      ) : BLOCKED_REASONS.includes(reason) && reason !== 'forbidden' ? (
        <Link to={window._l('/planes')}>
          {reason === 'subscription_exists' || reason.startsWith('approval') || reason === 'not_approved'
            ? t('subscription_blocked_goto_planes', 'Ir a Planes')
            : t('subscription_save_error_choose_plan', 'Elegí otro plan')}
        </Link>
      ) : null}
    </div>
  )
}
